/**
 * Kabuk socket'inden gelen 'imzaMessage' olayını SweetAlert2'ye vermeden önce süzer (DEV-3900).
 *
 * Olay kabuktan TÜM istemcilere (imzacı ve eİcraPro sekmeleri) yayınlanıyor; eskiden ham
 * nesne doğrudan `_swal.fire(...)`a veriliyordu, yani `html` gibi alanlar bu uygulamanın
 * origin'inde de çalışırdı. Kanonik alan listesi (kabuk ve vue-imza-app ile aynı):
 * title, text, icon (success|error|warning|info|question), allowOutsideClick (bool),
 * confirmButtonColor (#hex), confirmButtonText. Kabuk metni DEĞİŞTİRMEZ; kaçışlama burada:
 * title -> titleText ve text düz metin olarak gösterilir, confirmButtonText HTML sayıldığı
 * için kaçışlanır. Liste genişleyecekse kabuk ve iki tüketici birlikte güncellenir.
 */

const ICONLAR = ["success", "error", "warning", "info", "question"];
const RENK = /^#[0-9a-f]{3,8}$/i;
const EN_FAZLA_METIN = 500;
const EN_FAZLA_DUGME = 100;

export type ImzaMesajiIkonu = "success" | "error" | "warning" | "info" | "question";

export interface GuvenliImzaMesaji {
    titleText?: string;
    text?: string;
    icon?: ImzaMesajiIkonu;
    allowOutsideClick?: boolean;
    confirmButtonColor?: string;
    confirmButtonText?: string;
}

function htmlKacis(metin: string): string {
    return metin
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

function kisaMetin(deger: any, azami: number): string {
    return typeof deger === "string" ? deger.trim().slice(0, azami) : "";
}

/** Gösterilecek güvenli seçenekler; title ve text ikisi de yoksa gösterilecek bir şey yok: null. */
export function guvenliImzaMesaji(ham: any): GuvenliImzaMesaji | null {
    if (!ham || typeof ham !== "object") return null;
    const baslik = kisaMetin(ham.title, EN_FAZLA_METIN);
    const metin = kisaMetin(ham.text, EN_FAZLA_METIN);
    if (!baslik && !metin) return null;

    const sonuc: GuvenliImzaMesaji = {};
    if (baslik) sonuc.titleText = baslik;
    if (metin) sonuc.text = metin;
    if (typeof ham.icon === "string" && ICONLAR.indexOf(ham.icon) !== -1) sonuc.icon = ham.icon;
    if (typeof ham.allowOutsideClick === "boolean") sonuc.allowOutsideClick = ham.allowOutsideClick;
    if (typeof ham.confirmButtonColor === "string" && RENK.test(ham.confirmButtonColor)) sonuc.confirmButtonColor = ham.confirmButtonColor;
    const dugme = kisaMetin(ham.confirmButtonText, EN_FAZLA_DUGME);
    if (dugme) sonuc.confirmButtonText = htmlKacis(dugme);
    return sonuc;
}
